import { LegacyStack } from '@shopify/polaris';
import DropdownButton from '../Common/DropdownButton';

const ViewCustomerPrimaryActions = ({ customer, onEditCustomer, onEditRelation, onDelete }) => {
  const dropdownItems = [
    {
      content: 'Editar cliente',
      onAction: () => onEditCustomer(),
    },
    {
      content: 'Editar relación comercial',
      onAction: () => onEditRelation(),
    },
    {
      content: 'Borrar',
      onAction: () =>
        window.confirm('¿Estás seguro de que quieres eliminar el cliente?\n\nEsta acción es irreversible') &&
        onDelete(),
      disabled: customer && customer.ordersCount,
      destructive: true,
    },
  ];

  return (
    <LegacyStack>
      <DropdownButton
        title="Acciones"
        items={dropdownItems}
        buttonProps={{ disabled: dropdownItems.reduce((acc, cur) => acc && cur.disabled, true) }}
      />
    </LegacyStack>
  );
};

export default ViewCustomerPrimaryActions;
